module.exports = __webpack_public_path__ + "img/turnback.32f7065a.svg";